import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./teleworkabout.css"
import anime from 'animejs/lib/anime.es.js';

const TeleworkAbout = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>ABOUT</h1>
                        <p className="underabout">
                        Government agencies across the country faced an unprecedented shift to mass telework when the coronavirus pandemic arrived stateside. For most, remote working went from a convenient option to a mandate. And with it, things like device management, collaboration tools and connectivity via virtual private networks and the cloud became more important than ever. <br /><br />
 
This SNG Live virtual session will retrace the steps agencies took during the shift to telework, how they set their workforce up for mission continuity and what challenges they had to overcome.
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/wcc/r/2495071/4C8A5A4B56A70EFB0066412DE62E6CC1" target="_blank">WATCH NOW »</a>
                        <p className="cpe">
                        <b>Press:</b> Please submit a copy of your press credentials to <a href="mailto:events@scoopnewsgroup.com" target="_blank" className="pinkify">events@scoopnewsgroup.com</a> for consideration for press registration.
                            <br /><br />
                            
                            
                            
                        </p>
                    </div>
                    <div className="column grid2">
                        <div className="date">
                            
                            <h3><h4>Date:</h4> 07.14.20</h3>
                            <h3><h4>Time:</h4> 12:00 PM - 1:00 PM EST</h3>
                        </div>
                        
                        <a className="regmobwatch" href="https://event.on24.com/wcc/r/2495071/4C8A5A4B56A70EFB0066412DE62E6CC1" target="_blank">WATCH NOW »</a>
                        
                        <p className="cpemob">
                        <b>Press:</b> Please submit a copy of your press credentials to <a href="mailto:events@scoopnewsgroup.com" target="_blank" className="pinkify">events@scoopnewsgroup.com</a> for consideration for press registration.<br /><br />
                            
                            
                        </p>
                        <ReactModal 
                            className={styles.learnMoreModal}
                            overlayClassName="learnMoreOverlay"
                            isOpen={learnMoreModalState}
                            contentLabel="Navigation"
                            onRequestClose={hideLearnMoreModal}
                            aria={{
                                labelledby: "Navigation",
                                describedby: "Website navigation items"
                            }}
                            shouldReturnFocusAfterClose={false}
                            shouldFocusAfterRender={false}>
                        
                            <button className={styles.closeLearnMoreBut} onClick={hideLearnMoreModal}>&times;</button>
                            <div className={styles.menuWrap}>
                                <b>SNG Live 2020 Digital Transformation</b> attendees are eligible to receive continuing professional education (CPE) credits. 
                                Attendees can earn a maximum of 4 CPE credits in information technology.<br /><br />

                                In order to verify your CPEs, please document your name on the CPE attendance sheet located at the registration desk onsite. Be sure to return to the registration desk to document your time out. If sign in and/or sign out times are not documented, FedScoop is unable to verify your attendance and therefore cannot award CPE credit. Additional details:
                                <br /><br />
                                <img src="https://www.fedscoop.com/events/data-cloud-summit/assets/images/cperegistry_logo.jpg" className="cpe-logo" />
                                Delivery Method: Group-Live
                                <br />
                                Program Level: Intermediate
                                <br />
                                Prerequisites: Recommend previous experience in IT and technology
                                <br />
                                Advance Preparation: No advance preparation necessary
                                <br />
                                Contact <a href="mailto:beka.troutman@scoopnewsgroup.com" className="cpe-mail">Beka Troutman</a> 
                                &nbsp;for details on obtaining CPE credits at the event.
                                <br /><br />
                                Scoop News Group is registered with the National Association of State Boards of Accountancy 
                                (NASBA) as a sponsor of continuing professional education on the National Registry of CPE Sponsors. 
                                State boards of accountancy have final authority on the acceptance of individual courses for CPE credit. 
                                Complaints regarding registered sponsors may be submitted to the National Registry of 
                                CPE Sponsors through its website: www.learningmarket.org
                            </div>
                        </ReactModal>
                    </div>
                    <div className="column grid3">
                        <div className="grouplogos july14group">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "july")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                        <div className="botbuttons">
                            <h2 className="sponsor" id="Sponsors">BECOME A SPONSOR</h2>
                            <a className="pdf" href="https://www.fedscoop.com/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                            <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos july14group">
                        <h1>SPONSOR</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "july")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
            </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    <h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://www.fedscoop.com/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                    <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>
                </div>
            </div>
            
        </section>
    )
}

export default TeleworkAbout